import { Component, Inject, OnInit } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { SafeHtmlPipe } from "../../pipe/safehtmlpipe";

@Component({
  selector: "app-inbox-msg-full",
  templateUrl: "./inbox-msg-full.component.html",
  styleUrls: ["./inbox-msg-full.component.scss"],
  standalone: true,
  imports: [IonicModule, SafeHtmlPipe],
})
export class InboxMsgFullComponent implements OnInit {
  messageData: any;
  userId: string;
  constructor(
    private firestore: Firestore,
    private router: Router,
    private matDialogRef: MatDialogRef<InboxMsgFullComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService
  ) {
    if (data) {
      this.messageData = data;
    }
  }

  async ngOnInit(): Promise<void> {
    await this.authService
      ?.getUid("InboxMsgFullComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    if (this.data) {
      const path_id = "dQ2JLcXGOr5fbVp8gyIf";
      const doc_data = { auto_show: false, viewed: true, view_count: this.data.view_count + 1 };
      const dv = { docId: this.data?.id };
      const method = "update";

      this.authService.getV2CloudFunction("updatefirestoredoc", {
        path_id,
        doc_data,
        dv,
        method,
      }).subscribe({
        error: (error) => {
          console.error("Error updating Firestore document:", error);
          return error;
        }
      })
    }
  }

  goBack() {
    this.matDialogRef.close();
  }

  goToVoucher(link) {
    this.matDialogRef.close();
    this.router.navigateByUrl(`${link}`);
  }
}
